import React, { Component } from "react";
import { Layout, Row, Col, Typography } from "antd";
import { Icon } from "antd-mobile";
import "../../components/RcuControls/RcuControl.css";
import RcuGeneral from "./RcuGeneral";
import RcuSmall from "./RcuSmall";
import Rcu2701 from "./Rcu2701";
import Rcu2702 from "./Rcu2702";
import Rcu2703 from "./Rcu2703";

const { Content } = Layout;
const { Text } = Typography;

class RcuControlMain extends Component {
  constructor(props) {
    super(props);
    // 模拟房间号，可以通过 localStorage 或 props 传入
    const roomNo = localStorage.getItem("roomNo") || "2701";
    this.state = {
      roomNo: roomNo,
      // 模拟灯光控制状态
      lampControl: {
        master: { bright: false, soft: false },
        masterShowDetail: false,
        masterOff: false,
        bathroom: { bright: false, soft: false },
        bathroomShowDetail: false,
        bedroom: { bright: false, soft: false, night: false, readingleft: false, readingright: false, table: false, closet: false },
        bedroomShowDetail: false,
        livingroom: { bright: false, soft: false },
        livingroomShowDetail: false,
        diningroom: { bright: false, soft: false },
        diningroomShowDetail: false,
        bedroom2: { bright: false, soft: false, night: false, reading: false, reading2l: false },
        bedroom2ShowDetail: false,
        bathroom2: { bright: false, soft: false },
        bathroom2ShowDetail: false,
        table: false,
        closet: false,
        bedroom2Table: false,
        bedroom2Closet: false,
        pantry: false,
        workingTable: false,
        utility: false,
        balcony: false,
      },
      // 模拟设备控制状态
      deviceControl: {
        makeUpRoom: false,
        dnd: false,
      },
      // 模拟窗帘控制
      livingRoomControl: {
        blindUp: false,
        blindDown: false,
      },
      livingRoomSheerControl: {
        open: false,
        close: false,
      },
      bedRoomBlindControl: {
        open: false,
        close: false,
      },
      bedRoomSheerControl: {
        open: false,
        close: false,
      },
      bedRoom2BlindControl: {
        up: false,
        down: false,
      },
      bedRoom2SheerControl: {
        up: false,
        down: false,
      },
      bathRoomSheerControl: {
        open: false,
        close: false,
      },
      bathroomBlindControl: {
        open: false,
        close: false,
      },
      livingBedRoomControl: {
        blindUp: false,
        blindDown: false,
      },
      // 模拟空调状态
      livingroomAc: false,
      bedroomAc: false,
      bedroom2Ac: false,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  // 判断房间类型
  isSmallZone = (roomNo) => {
    const smallRooms = ["1801", "1802", "1901", "1902"];
    return smallRooms.includes(roomNo);
  };

  is2703 = (roomNo) => {
    return roomNo === "2703";
  };

  is2702 = (roomNo) => {
    return roomNo === "2702";
  };

  is2701 = (roomNo) => {
    return roomNo === "2701";
  };

  isHighZone07 = (roomNo) => {
    const highZone07Rooms = ["2707", "2807"];
    return highZone07Rooms.includes(roomNo);
  };

  // 设置状态的通用方法
  toggleState = (path) => {
    this.setState((prevState) => {
      const keys = path.split(".");
      const newState = { ...prevState };
      let current = newState;

      for (let i = 0; i < keys.length - 1; i++) {
        current[keys[i]] = { ...current[keys[i]] };
        current = current[keys[i]];
      }

      const lastKey = keys[keys.length - 1];
      current[lastKey] = !current[lastKey];

      return newState;
    });
  };

  // 设置所有子项为 false
  setAllFalse = (path) => {
    this.setState((prevState) => {
      const keys = path.split(".");
      const newState = { ...prevState };
      let current = newState;

      for (let i = 0; i < keys.length - 1; i++) {
        current[keys[i]] = { ...current[keys[i]] };
        current = current[keys[i]];
      }

      const lastKey = keys[keys.length - 1];
      const obj = current[lastKey];
      const resetObj = {};
      Object.keys(obj).forEach((key) => {
        resetObj[key] = false;
      });
      current[lastKey] = resetObj;

      return newState;
    });
  };

  // 模拟 rcuControlStore 的方法
  getRcuControlStore = () => {
    return {
      deviceControl: this.state.deviceControl,
      lampControl: this.state.lampControl,
      livingRoomControl: this.state.livingRoomControl,
      livingRoomSheerControl: this.state.livingRoomSheerControl,
      bedRoomBlindControl: this.state.bedRoomBlindControl,
      bedRoomSheerControl: this.state.bedRoomSheerControl,
      bedRoom2BlindControl: this.state.bedRoom2BlindControl,
      bedRoom2SheerControl: this.state.bedRoom2SheerControl,
      bathRoomSheerControl: this.state.bathRoomSheerControl,
      bathroomBlindControl: this.state.bathroomBlindControl,
      livingBedRoomControl: this.state.livingBedRoomControl,
      livingroomAc: this.state.livingroomAc,
      bedroomAc: this.state.bedroomAc,
      bedroom2Ac: this.state.bedroom2Ac,
      isSmallZone: this.isSmallZone,
      is2703: this.is2703,
      is2702: this.is2702,
      is2701: this.is2701,
      isHighZone07: this.isHighZone07,
      // 设备控制方法
      setMakeUpRoom: () => this.toggleState("deviceControl.makeUpRoom"),
      setDnd: () => this.toggleState("deviceControl.dnd"),
      // Master 控制
      setMasterAllOff: () => this.setAllFalse("lampControl.master"),
      setMasterBright: () => this.toggleState("lampControl.master.bright"),
      setMasterSoft: () => this.toggleState("lampControl.master.soft"),
      setmasterShowDetail: () => this.toggleState("lampControl.masterShowDetail"),
      setMasterOff: () => this.toggleState("lampControl.masterOff"),
      // Bathroom 控制
      setBathroomAllOff: () => this.setAllFalse("lampControl.bathroom"),
      setBathroomBright: () => this.toggleState("lampControl.bathroom.bright"),
      setBathroomSoft: () => this.toggleState("lampControl.bathroom.soft"),
      setbathroomShowDetail: () => this.toggleState("lampControl.bathroomShowDetail"),
      // Bedroom 控制
      setBedroomAllOff: () => this.setAllFalse("lampControl.bedroom"),
      setBedroomBright: () => this.toggleState("lampControl.bedroom.bright"),
      setBedroomSoft: () => this.toggleState("lampControl.bedroom.soft"),
      setBedroomNight: () => this.toggleState("lampControl.bedroom.night"),
      setBedroomReadingLeft: () => this.toggleState("lampControl.bedroom.readingleft"),
      setBedroomReadingRight: () => this.toggleState("lampControl.bedroom.readingright"),
      setBedroomTable: () => this.toggleState("lampControl.bedroom.table"),
      setBedroomCloset: () => this.toggleState("lampControl.bedroom.closet"),
      setbedroomShowDetail: () => this.toggleState("lampControl.bedroomShowDetail"),
      // Living Room 控制
      setLivingroomAllOff: () => this.setAllFalse("lampControl.livingroom"),
      setLivingroomBright: () => this.toggleState("lampControl.livingroom.bright"),
      setLivingroomSoft: () => this.toggleState("lampControl.livingroom.soft"),
      setlivingroomShowDetail: () => this.toggleState("lampControl.livingroomShowDetail"),
      setLivingRoomBlindUp: () => this.toggleState("livingRoomControl.blindUp"),
      setLivingRoomBlindDown: () => this.toggleState("livingRoomControl.blindDown"),
      setLivingRoomSheerOpen: () => this.toggleState("livingRoomSheerControl.open"),
      setLivingRoomSheerClose: () => this.toggleState("livingRoomSheerControl.close"),
      setLivingroomAc: () => this.toggleState("livingroomAc"),
      // Dining Room 控制
      setDiningroomAllOff: () => this.setAllFalse("lampControl.diningroom"),
      setDiningroomBright: () => this.toggleState("lampControl.diningroom.bright"),
      setDiningroomSoft: () => this.toggleState("lampControl.diningroom.soft"),
      setdiningroomShowDetail: () => this.toggleState("lampControl.diningroomShowDetail"),
      // Bedroom 2 控制
      setBedroom2AllOff: () => this.setAllFalse("lampControl.bedroom2"),
      setBedroom2Bright: () => this.toggleState("lampControl.bedroom2.bright"),
      setBedroom2Soft: () => this.toggleState("lampControl.bedroom2.soft"),
      setBedroom2Night: () => this.toggleState("lampControl.bedroom2.night"),
      setBedroom2Reading: () => this.toggleState("lampControl.bedroom2.reading"),
      setBedroom2Reading2l: () => this.toggleState("lampControl.bedroom2.reading2l"),
      setbedroom2ShowDetail: () => this.toggleState("lampControl.bedroom2ShowDetail"),
      setBedroom2Ac: () => this.toggleState("bedroom2Ac"),
      setBedroom2Table: () => this.toggleState("lampControl.bedroom2Table"),
      setBedroom2Closet: () => this.toggleState("lampControl.bedroom2Closet"),
      setBedRoom2BlindUp: () => this.toggleState("bedRoom2BlindControl.up"),
      setBedRoom2BlindDown: () => this.toggleState("bedRoom2BlindControl.down"),
      setBedRoom2SheerUp: () => this.toggleState("bedRoom2SheerControl.up"),
      setBedRoom2SheerDown: () => this.toggleState("bedRoom2SheerControl.down"),
      // Bathroom 2 控制
      setBathroom2AllOff: () => this.setAllFalse("lampControl.bathroom2"),
      setBathroom2Bright: () => this.toggleState("lampControl.bathroom2.bright"),
      setBathroom2Soft: () => this.toggleState("lampControl.bathroom2.soft"),
      setbathroom2ShowDetail: () => this.toggleState("lampControl.bathroom2ShowDetail"),
      // 其他控制
      setTable: () => this.toggleState("lampControl.table"),
      setCloset: () => this.toggleState("lampControl.closet"),
      setPantry: () => this.toggleState("lampControl.pantry"),
      setWorkingTable: () => this.toggleState("lampControl.workingTable"),
      setUtility: () => this.toggleState("lampControl.utility"),
      setBalcony: () => this.toggleState("lampControl.balcony"),
      setBedroomAc: () => this.toggleState("bedroomAc"),
      // Bedroom 窗帘控制
      setBedRoomBlindOpen: () => this.toggleState("bedRoomBlindControl.open"),
      setBedRoomBlindClose: () => this.toggleState("bedRoomBlindControl.close"),
      setBedRoomSheerOpen: () => this.toggleState("bedRoomSheerControl.open"),
      setBedRoomSheerClose: () => this.toggleState("bedRoomSheerControl.close"),
      // Bathroom 窗帘控制
      setBathRoomSheerOpen: () => this.toggleState("bathRoomSheerControl.open"),
      setBathRoomSheerClose: () => this.toggleState("bathRoomSheerControl.close"),
      setBathroomBlindOpen: () => this.toggleState("bathroomBlindControl.open"),
      setBathroomBlindClose: () => this.toggleState("bathroomBlindControl.close"),
      // Living Bedroom 控制
      setLivingBedRoomBlindUp: () => this.toggleState("livingBedRoomControl.blindUp"),
      setLivingBedRoomBlindDown: () => this.toggleState("livingBedRoomControl.blindDown"),
    };
  };

  // RENDER
  headerRender = () => {
    return (
      <Row>
        <Col span={24} className="col-header">
          <Row>
            <Col
              span={4}
              className="col-header-back"
              onClick={this.backToHomePageOnClick}
            >
              <Icon type="left" size="lg" color="#FFF" />
            </Col>
            <Col span={16} className="col-header-text">
              <Text className="text-header">
                Room Control Unit
              </Text>
            </Col>
            <Col span={4} />
          </Row>
        </Col>
      </Row>
    );
  };

  getRcu = () => {
    const roomNo = this.state.roomNo;
    const rcuControlStore = this.getRcuControlStore();

    if (this.is2703(roomNo)) {
      return <Rcu2703 rcuControlStore={rcuControlStore} />;
    }

    if (this.is2702(roomNo)) {
      return <Rcu2702 rcuControlStore={rcuControlStore} />;
    }

    if (this.is2701(roomNo)) {
      return <Rcu2701 rcuControlStore={rcuControlStore} />;
    }

    if (this.isSmallZone(roomNo)) {
      return <RcuSmall rcuControlStore={rcuControlStore} />;
    }

    return <RcuGeneral rcuControlStore={rcuControlStore} />;
  };

  // ON CLICK
  backToHomePageOnClick = () => {
    this.props.history.push("/");
  };

  render() {
    return (
      <Layout className="layout-page">
        <Content>
          {/* Header */}
          {this.headerRender()}

          {/* Main */}
          <Row className="row-rcu">
            <Col span={1} />
            <Col span={22} className="col-rcu">
              {this.getRcu()}
            </Col>
            <Col span={1} />
          </Row>
        </Content>
      </Layout>
    );
  }
}

export default RcuControlMain;
